export default {"src":"/_next/static/media/grid-vertical.012b5c61.svg","height":1482,"width":1717,"blurWidth":0,"blurHeight":0};